import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import CampaignDialog from "./CampaignDialog";

const QUEST_STATUSES = ["new", "active", "completed", "failed"];

const QuestDialog = ({ form, isOpen, participants, onChange, onClose, onSubmit }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isOpen) return;
    onChange((current) => ({
      ...current,
      assignedCharacterIds: current.assignedCharacterIds.filter((characterId) =>
        participants.some((character) => character.id === characterId)
      ),
    }));
  }, [isOpen, onChange, participants]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!form.title.trim()) return;

    onSubmit({
      ...form,
      title: form.title.trim(),
      description: form.description.trim(),
      notes: form.notes.trim(),
    });
  };

  return (
    <CampaignDialog
      description={t("campaigns.questDialogHint")}
      isOpen={isOpen}
      onClose={onClose}
      title={t("campaigns.addQuest")}
      titleEyebrow={t("campaigns.sections.questsEyebrow")}
    >
      <form className="campaign-form-grid" onSubmit={handleSubmit}>
        <label htmlFor="quest-title">
          {t("campaigns.form.questTitle")}
          <input
            id="quest-title"
            name="quest-title"
            value={form.title}
            onChange={(event) =>
              onChange((current) => ({ ...current, title: event.target.value }))
            }
          />
        </label>
        <label htmlFor="quest-description">
          {t("campaigns.form.description")}
          <textarea
            id="quest-description"
            name="quest-description"
            value={form.description}
            onChange={(event) =>
              onChange((current) => ({
                ...current,
                description: event.target.value,
              }))
            }
          />
        </label>
        <label htmlFor="quest-status">
          {t("campaigns.form.questStatus")}
          <select
            id="quest-status"
            name="quest-status"
            value={form.status}
            onChange={(event) =>
              onChange((current) => ({ ...current, status: event.target.value }))
            }
          >
            {QUEST_STATUSES.map((status) => (
              <option key={status} value={status}>
                {t(`campaigns.questStatuses.${status}`)}
              </option>
            ))}
          </select>
        </label>
        <label htmlFor="quest-notes">
          {t("common.notes")}
          <textarea
            id="quest-notes"
            name="quest-notes"
            value={form.notes}
            onChange={(event) =>
              onChange((current) => ({ ...current, notes: event.target.value }))
            }
          />
        </label>
        {participants.length > 0 && (
          <div>
            <p className="campaign-dialog-subtitle">{t("campaigns.form.questAssigned")}</p>
            <div className="campaign-chip-row">
              {participants.map((character) => (
                <label className="campaign-chip campaign-chip-selectable" key={character.id}>
                  <input
                    checked={form.assignedCharacterIds.includes(character.id)}
                    type="checkbox"
                    onChange={() =>
                      onChange((current) => ({
                        ...current,
                        assignedCharacterIds: current.assignedCharacterIds.includes(character.id)
                          ? current.assignedCharacterIds.filter((id) => id !== character.id)
                          : [...current.assignedCharacterIds, character.id],
                      }))
                    }
                  />
                  {character.characterName || t("characters.unnamed")}
                </label>
              ))}
            </div>
          </div>
        )}
        <footer className="campaign-dialog-footer">
          <button className="campaign-ghost-button" type="button" onClick={onClose}>
            {t("common.cancel")}
          </button>
          <button className="campaign-primary-button" type="submit">
            {t("common.create")}
          </button>
        </footer>
      </form>
    </CampaignDialog>
  );
};

export default QuestDialog;
